import { render, staticRenderFns } from "./Answers.vue?vue&type=template&id=a64b4ede&scoped=true&"
import script from "./Answers.vue?vue&type=script&lang=ts&"
export * from "./Answers.vue?vue&type=script&lang=ts&"
import style0 from "./Answers.vue?vue&type=style&index=0&id=a64b4ede&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a64b4ede",
  null
  
)

export default component.exports